import React from 'react';
import PropTypes from 'prop-types';

export default function AssetValidationErrorsDisplay(props) {
  const { data, dataLoading } = props;
  return (
    <div className="position-absolute h-100 w-100 bg-white rounded-lg px-3 py-2 d-flex flex-column">
      <div className="h-100 w-100 overflow-auto">
        <table className="table">
          <thead>
            <tr className="sticky-top bg-white">
              <th className="border-top-0">Timestamp</th>
              <th className="border-top-0">Message</th>
            </tr>
          </thead>
          <tbody className={dataLoading || !data.length ? 'd-none' : ''}>
            {data.map((e) => {
              return (
                <tr key={e.timestamp}>
                  <td>{new Date(e.timestamp).toISOString()}</td>
                  <td>{e.message}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

AssetValidationErrorsDisplay.propTypes = {
  tab: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  error: PropTypes.string,
  dataLoading: PropTypes.bool,
  sort: PropTypes.shape({
    by: PropTypes.oneOf(['Timestamp']),
    order: PropTypes.oneOf(['asc', 'desc']),
  }),
};

AssetValidationErrorsDisplay.defaultProps = { data: [], sort: {} };
